export default defineNuxtRouteMiddleware((to) => {
  const config = useRuntimeConfig()

  const redirectEnabled =
    String(config.public.redirectAllToHome || '')
      .trim()
      .toLowerCase() === 'true'

  if (!redirectEnabled) {
    return
  }

  const path = String(to.path || '/').toLowerCase()

  // Home continua acessível.
  if (path === '/') {
    return
  }

  // Área administrativa continua acessível.
  if (path === '/admin' || path.startsWith('/admin/')) {
    return
  }

  // Arquivos e recursos internos do Nuxt.
  if (
    path.startsWith('/_nuxt/') ||
    path.startsWith('/images/') ||
    path.startsWith('/img/') ||
    path.startsWith('/icons/') ||
    path.startsWith('/uploads/') ||
    path === '/favicon.ico' ||
    path === '/robots.txt' ||
    path === '/sitemap.xml'
  ) {
    return
  }

  return navigateTo('/', {
    redirectCode: 302,
    replace: true
  })
})
